import { Empty, Loaded, Loading } from 'core/state';
import {
  TimesheetExcludedUserMap,
  TimesheetExcludedUsers,
  TimesheetExcludedUserState,
  UserId,
} from './types';

export const empty = (): TimesheetExcludedUsers => Empty();
export const loading = (): TimesheetExcludedUsers => Loading();
export const loaded = (x: TimesheetExcludedUserMap): TimesheetExcludedUsers =>
  Loaded(x);
export const add =
  (userIds: UserId[]) =>
  (state: TimesheetExcludedUsers): TimesheetExcludedUsers => {
    if (state[0] === 'loading') {
      return state;
    }

    return Loaded(
      userIds.reduce(
        (r, id) => ({
          ...r,
          [id]: TimesheetExcludedUserState.Adding,
        }),
        state[1] ?? {},
      ),
    );
  };
export const added =
  (userIds: UserId[]) =>
  (state: TimesheetExcludedUsers): TimesheetExcludedUsers => {
    if (state[0] === 'loading') {
      return state;
    }

    return Loaded(
      userIds.reduce((r, id) => {
        const { [id]: status, ...rest } = r;

        return status === TimesheetExcludedUserState.Adding
          ? { ...rest, [id]: TimesheetExcludedUserState.Just }
          : r;
      }, state[1] ?? {}),
    );
  };
export const unadded =
  (userIds: UserId[]) =>
  (state: TimesheetExcludedUsers): TimesheetExcludedUsers => {
    if (state[0] === 'loading') {
      return state;
    }

    return Loaded(
      userIds.reduce((r, id) => {
        const { [id]: status, ...rest } = r;

        return status === TimesheetExcludedUserState.Adding ? rest : r;
      }, state[1] ?? {}),
    );
  };
export const remove =
  (userIds: UserId[]) =>
  (state: TimesheetExcludedUsers): TimesheetExcludedUsers => {
    if (state[0] === 'loading') {
      return state;
    }

    return Loaded(
      userIds.reduce((r, id) => {
        const { [id]: status, ...rest } = r;

        return { ...rest, [id]: TimesheetExcludedUserState.Removing };
      }, state[1] ?? {}),
    );
  };
export const removed =
  (userIds: UserId[]) =>
  (state: TimesheetExcludedUsers): TimesheetExcludedUsers => {
    if (state[0] === 'loading') {
      return state;
    }

    return Loaded(
      userIds.reduce((r, id) => {
        const { [id]: status, ...rest } = r;

        return rest;
      }, state[1] ?? {}),
    );
  };
export const unremove =
  (userIds: UserId[]) =>
  (state: TimesheetExcludedUsers): TimesheetExcludedUsers => {
    if (state[0] === 'loading') {
      return state;
    }

    return Loaded(
      userIds.reduce((r, id) => {
        const { [id]: status, ...rest } = r;

        return status === TimesheetExcludedUserState.Removing
          ? { ...rest, [id]: TimesheetExcludedUserState.Just }
          : r;
      }, state[1] ?? {}),
    );
  };
